module.exports = __webpack_public_path__ + "img/52114144_L.225686c4.png";